<template>
  <Modal @close="$emit('close')" :title="title">
    <div slot="body" class="row col-10 mx-auto">
      <table class="table elevation-1" v-if="data.length">
        <thead class="text-logo">
          <tr>
            <th>Estudiantes</th>
            <th>Avance</th>
          </tr>
        </thead>
        <tbody class="text-primary">
          <template v-for="(item, i) in data">
            <tr :key="i">
              <td>{{ item.user.firstname }} {{ item.user.lastname }}</td>
              <td>{{ item.progressPercentage }}</td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="row" v-else>
        <div class="col text-center text-gray">
          <span>
            No existen datos para mostrar
          </span>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: "GeneralProgress",
  components: {
    Modal,
  },
  props: ["data"],
  data() {
    return {
      title: "Porcentaje de avance en la lectura",
    };
  },
};
</script>
